const REACT_APP_API_PROVIDERS: string = window.REACT_APP_API_PROVIDERS || "";
const REACT_APP_API_ESIM: string = window.REACT_APP_API_ESIM || "";
const REACT_APP_API_SIM: string = window.REACT_APP_API_SIM || "";
const REACT_APP_API_ACCOUNTS: string = window.REACT_APP_API_ACCOUNTS || "";
const REACT_APP_API_PAYMENT: string = window.REACT_APP_API_PAYMENT || "";
const REACT_APP_API_PAYMENTS: string = window.REACT_APP_API_PAYMENTS || "";
const REACT_APP_API_AUCTIONS: string = window.REACT_APP_API_AUCTIONS || "";
const REACT_APP_GOOGLE_MAPS_API_KEY: string =
  process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "";
const REACT_APP_TICKETING_ORIGIN: string =
  window.REACT_APP_TICKETING_ORIGIN || "";
const HOME_ROUTERS_PLANS =  [
  {
      "nameEn": "Vnet 355",
      "nameAr": "في نت 355",
      "providerId": 12,
      "dataEn": "Unlimited GBs",
      "dataAr": "إنترنت غير محدود",
      "downloadSpeedEn": "No speed limitation",
      "downloadSpeedAr": "بدون حدود للسرعة",
      "uploadSpeedEn": "No speed limitation",
      "uploadSpeedAr": "بدون حدود لسرعة الرفع",
      "priceEn": "213 SAR (VAT excluded) for the first 12 months, followed by the regular price of 355 SAR for the remaining commitment period.",
      "priceAr": "213 ريال (غير شامل الضريبة) لأول 12 شهر، ثم يعود السعر إلى 355 ريال لبقية فترة الالتزام.",
      "discountedPrice": 213,
      "regularPrice": 408.25,
    "show":false,
      "currency": "SAR",
      "discountDurationMonths": 12,
      "commitmentPeriodMonths": 18,
      "routerTypeEn": "Huawei 5G Advance Router",
      "routerTypeAr": "راوتر هواوي 5G المتقدم",
      "routerPriceEn": "Included in the monthly fee amount.",
      "routerPriceAr": "مشمول ضمن قيمة الاشتراك الشهري.",
      "imageUrl": "",
      "packageDetailsEn": [
        "Unlimited download",
        "No speed limitation on download and upload",
        "Free delivery",
        "No location restrictions",
        "Free device",
        "Plug and play"
      ],
      "packageDetailsAr": [
        "تحميل غير محدود",
        "بدون حدود لسرعة التحميل والرفع",
        "توصيل مجاني",
        "بدون قيود على الموقع",
        "جهاز مجاني",
        "جاهز للاستخدام مباشرة"
      ],
      "marketingMessageEn": "Experience Untethered 5G Internet.",
      "marketingMessageAr": "استمتع بتجربة إنترنت 5G بلا حدود.",
      "termsEn": [
        "Commitment period: 18 months",
        "Customers need to sign a promissory note of 758 SAR for the device",
        "Customer needs to pay 31 SAR for each unbilled month in case of early termination"
      ],
      "termsAr": [
        "فترة الالتزام: 18 شهرًا",
        "يجب على العميل توقيع سند لأمر بقيمة 758 ريال للجهاز",
        "يجب على العميل دفع 31 ريال عن كل شهر غير مفوتر في حال الإلغاء المبكر"
      ]
    }
];
export {
  REACT_APP_API_PROVIDERS,
  REACT_APP_API_ESIM,
  REACT_APP_API_SIM,
  REACT_APP_API_ACCOUNTS,
  REACT_APP_API_PAYMENT,
  REACT_APP_API_PAYMENTS,
  REACT_APP_API_AUCTIONS,
  REACT_APP_GOOGLE_MAPS_API_KEY,
  REACT_APP_TICKETING_ORIGIN,
  HOME_ROUTERS_PLANS,
};
